import React from 'react'
import { canMoveInOnlyIcons } from '../../utils/rules'
import { RowIconsSettings } from './RowIconsSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {}

export const dynamicProps = []

export const RowIcons = withBlock((props) => {
  const blockProps = {
    ...defaultProps,
    ...props.block,
  }
  const { layout } = blockProps
  const { children } = props

  const _ = props.renderValue

  return (
    <div className={`block-row-icons ${props.className}`} ref={(ref) => props.retRef(ref)}>
      {children?.props?.children}
    </div>
  )
}, defaultProps)

RowIcons.craft = withCraft({
  name: 'RowIcons',
  defaultProps: defaultProps,
  settings: RowIconsSettings,
  canMoveIn: canMoveInOnlyIcons,
})
